import { jsx } from 'react/jsx-runtime';

// NOTE: This is a different checkmark icon than the one in the Icons component
var CheckmarkIcon = function CheckmarkIcon() {
  return jsx("svg", {
    width: "16",
    height: "16",
    focusable: false,
    "data-testid": "CheckIcon",
    "aria-hidden": true,
    className: "cogs-v10 cogs-checkbox__checkmark",
    viewBox: "-2 -3 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("path", {
      d: "M3.88909 5.99497C4.08435 6.19024 4.40093 6.19024 4.59619 5.99497L9.82878 0.762385C10.024 0.567123 10.3406 0.567122 10.5359 0.762385L11.5258 1.75233C11.7211 1.9476 11.7211 2.26418 11.5258 2.45944L4.59619 9.38909C4.40093 9.58435 4.08435 9.58435 3.88909 9.38909L0.353553 5.85355C0.158291 5.65829 0.158291 5.34171 0.353553 5.14645L1.3435 4.1565C1.53877 3.96123 1.85535 3.96123 2.05061 4.1565L3.88909 5.99497Z",
      fill: "currentColor"
    })
  });
};
var IndeterminateIcon = function IndeterminateIcon() {
  return jsx("svg", {
    width: "16",
    height: "16",
    focusable: false,
    "data-testid": "IndeterminateIcon",
    "aria-hidden": true,
    className: "cogs-v10 cogs-checkbox__checkmark",
    viewBox: "-2 -2 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsx("rect", {
      width: "8",
      height: "8",
      rx: "1",
      fill: "currentColor"
    })
  });
};

export { CheckmarkIcon, IndeterminateIcon };
